import React from 'react';
import './experience.css';
import portfolioConfig from '../../config/portfolioConfig';

const Experience = () => {
  const { experience } = portfolioConfig;

  return (
    <section id="experience" className="experience-section section">
      <div className="container experience-section__container">
        <div className="experience-section__intro">
          <div>
            <p className="section-eyebrow">Journey</p>
            <h2>Recent experience framed around what got shipped, not inflated timelines.</h2>
          </div>
          <p className="section-copy">
            The new version removes the overproduced timeline styling and keeps the emphasis on the
            work itself: the context, the delivery, and the outcomes that matter.
          </p>
        </div>

        <div className="experience-list">
          {experience.map((item) => (
            <article key={`${item.period}-${item.title}`} className="experience-card panel">
              <div className="experience-card__topline">
                <span>{item.period}</span>
                <p>{item.company}</p>
              </div>
              <h3>{item.title}</h3>
              <p className="experience-card__summary">{item.summary}</p>
              <ul className="experience-card__wins">
                {item.wins.map((win) => (
                  <li key={win}>{win}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
